import { buildRedirectQueryValue, resolveAuthRouteRedirect } from '~/utils/authRedirect';
import type AuthUser from '~/types/authUser';

export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn, user } = useUserSession();
  const localePath = useLocalePath();
  // colaborador vai para /dashboards/colaborador; demais para /dashboards/manutencoes
  const isCollaborator = (user.value as AuthUser | null)?.roleName === 'collaborator';
  const defaultDashboard = localePath(isCollaborator ? '/dashboards/colaborador' : '/dashboards/manutencoes');

  // redireciona usuário logado que acessa /auth/login para o dashboard correto
  const authRouteRedirect = resolveAuthRouteRedirect({
    loggedIn: loggedIn.value,
    path: to.path,
    redirect: to.query.redirect,
    defaultPath: defaultDashboard
  });

  if (authRouteRedirect) {
    return navigateTo(authRouteRedirect);
  }

  // Skip authentication for public routes
  const publicRoutes = ['/auth', '/pt/auth', '/api/edifica-app/docs', '/public', '/pt/public'];

  // Check if current path is a public route
  if (publicRoutes.some((route) => to.path.startsWith(route))) {
    return;
  }

  if (!loggedIn.value) {
    return navigateTo({
      path: localePath('/auth/login'),
      query: {
        redirect: buildRedirectQueryValue(to)
      }
    });
  }

  // redireciona (/) para o dashboard principal (index.vue foi removido)
  const normalizedPath = to.path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
  if (normalizedPath === '/') {
    return navigateTo(defaultDashboard, { replace: true });
  }
});
